import { useEffect, useRef } from 'react';

export const useScrollPosition = (key, vacancyId = null) => {
  const scrollRef = useRef(null);
  const storage = vacancyId ? localStorage : sessionStorage;
  const scrollPositionKey = vacancyId ? `scrollPosition_${key}_v${vacancyId}` : `scrollPosition_${key}`;
  
  // Восстанавливаем позицию скролла при монтировании
  useEffect(() => {
    if (scrollRef.current) {
      const savedPosition = storage.getItem(scrollPositionKey);
      if (savedPosition) {
        const position = parseInt(savedPosition, 10);
        // Небольшая задержка для того, чтобы контент успел загрузиться
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTop = position;
          }
        }, 100);
      }
    }
  }, [scrollPositionKey, storage]);
  
  // Сохраняем позицию скролла при скроллинге
  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        storage.setItem(scrollPositionKey, scrollRef.current.scrollTop.toString());
      }
    };
    
    const element = scrollRef.current;
    if (element) {
      element.addEventListener('scroll', handleScroll, { passive: true });
      
      return () => {
        element.removeEventListener('scroll', handleScroll);
      };
    }
  }, [scrollPositionKey, storage]);
  
  return scrollRef;
};
